import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.blood_glucose,
  },
  timeWindow: 7 * 12,
  childProps: {
    title: chartTitles.blood_glucose,
    legendEnabled: true,
    series: [
      {
        type: 'blood_glucose_before',
        label: 'Before Eating',
      },
      {
        type: 'blood_glucose_after',
        label: 'After Eating',
      },
    ],
    yAxisLabel: 'Blood Glucose (mmol/L)',
  },
})
